import { IconProps } from "./types";

export default function IcoBackButton({
	color = "#202124",
	width = "15.75",
	height = "18"
}: IconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 16 19"
			fill="none"
		>
			<g clipPath="url(#clip0_647_1696)">
				<path
					d="M0.330566 8.45566C-0.108887 8.89512 -0.108887 9.60879 0.330566 10.0482L5.95557 15.6732C6.39502 16.1127 7.10869 16.1127 7.54814 15.6732C7.9876 15.2338 7.9876 14.5201 7.54814 14.0807L3.83916 10.3752H14.6251C15.2474 10.3752 15.7501 9.87246 15.7501 9.2502C15.7501 8.62793 15.2474 8.1252 14.6251 8.1252H3.84268L7.54463 4.41973C7.98408 3.98027 7.98408 3.2666 7.54463 2.82715C7.10518 2.3877 6.3915 2.3877 5.95205 2.82715L0.327051 8.45215L0.330566 8.45566Z"
					fill={color}
				/>
			</g>
			<defs>
				<clipPath id="clip0_647_1696">
					<path d="M0 0.25H15.75V18.25H0V0.25Z" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
